<div class="content">
    <h2 data-qa="tnb-sub-header">Netzbetreiber</h2>

    <tnb-netzbetreiber-list></tnb-netzbetreiber-list>
</div>

